import React from "react";

interface Props {
  color: string;
}

export const Badge = (props: Props) => {
  const { color } = props;

  return <div className={`fr-h-2 fr-w-2 fr-rounded-full fr-inline-block`} style={{ backgroundColor: color }}></div>;
};
